/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React from 'react';

import { CardElement } from '@stripe/react-stripe-js';
import {
  StripeCardElementChangeEvent,
  StripeElementType,
} from '@stripe/stripe-js';
import chroma from 'chroma-js';
import cx from 'classnames';

import { FieldErrorMessage } from 'components/Form/FieldErrorMessage/FieldErrorMessage';

import { useGGTheme } from 'hooks/theme/useGGTheme';

import s from './StripeElement.module.css';

type TStripeElementProps = {
  id: string;
  errorMessage?: string;
  onChange: (event: StripeCardElementChangeEvent) => void;
  onBlur?: (event: { elementType: StripeElementType }) => void;
  onFocus?: (event: { elementType: StripeElementType }) => void;
  hasFocus?: boolean;
  hiddenLabel?: boolean;
};

const StripeElement = ({
  id,
  errorMessage,
  onChange,
  onBlur,
  onFocus,
  hasFocus,
  hiddenLabel,
}: TStripeElementProps) => {
  const { theme } = useGGTheme();

  let textPrimary = (theme?.palette.textPrimary as string) || '#FFFFFF';
  const textTertiary = (theme?.palette.textTertiary as string) || '#FFFFFF';
  let placeholderColor = `${chroma(textTertiary)}`;

  if (typeof window !== 'undefined') {
    textPrimary =
      getComputedStyle(document.body).getPropertyValue('--text-primary') ||
      '#FFFFFF';
    placeholderColor = `${chroma(textPrimary)}90`;
  }

  const textColor = `${chroma(textPrimary)}`;

  return (
    <div
      className={cx(
        s.root,
        hasFocus ? s.stripeFocus : '',
        errorMessage ? s.error : '',
      )}
    >
      <label htmlFor={id} className={s.label} hidden={hiddenLabel}>
        <span>Credit Card</span>
      </label>
      <div className={s.inputContainer}>
        <CardElement
          id={id}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          className={s.stripeElem}
          options={{
            style: {
              base: {
                fontSize: '16px',
                color: textColor,
                fontFamily: 'Inter, Helvetica, Arial, sans-serif',
                '::placeholder': {
                  color: `${placeholderColor}`,
                },
                ':-webkit-autofill': {
                  color: textColor,
                },
              },
              invalid: {
                color: '#9e2146',
              },
            },
          }}
        />

        <FieldErrorMessage error={errorMessage} id={id} />
      </div>
    </div>
  );
};

export { StripeElement };
